<template>
  <div>
    <b-modal
        id="catalog-product-modal"
        centered
        :title="$t('pages.catalog.product_modal.title')"
        title-class="font-18"
        @ok="handleOk"
        @close="close"
        lazy
        size="lg"
        :ok-title="$t('pages.catalog.product_modal.ok')"
        :cancel-title="$t('pages.catalog.product_modal.cancel')"
        @hidden="handleHidden"
    >
      <div>
        <div>
          <div class="row mb-3 justify-content-between">
            <div class="col-xl-3 col-sm-6">
              <div class="mt-2">
                <h5>{{ $t('pages.catalog.product_modal.your_products') }}</h5>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6">
              <DataTableSearch v-model="search" :place-holder="$t('pages.catalog.product_modal.search')"/>
            </div>
          </div>
        </div>

        <div class="bg-light">
          <simplebar class="area">
            <b-row>
              <b-col sm="12" xl="4" lg="4" md="12" v-for="product in catalog" :key="product.id">
                <label class="mb-2">
                  <input
                      @click="selectProduct($event, product)"
                      type="checkbox"
                      style="display: none"
                      v-model="product.selected"
                  />
                  <b-card no-body
                          style="cursor: pointer"
                          :class="{'border border-success' : product.selected}">
                    <b-card-body>
                      <div>
                        <div class="float-end ms-2">
                          <b-checkbox v-model="product.selected" button-variant="danger"/>
                        </div>
                        <div class="me-3">
                          <div class="media">
                            <div class="me-3">
                              <b-avatar variant="light" class="img-thumbnail product-img" :src="product.image_url"
                                        size="2rem"></b-avatar>
                            </div>
                            <div class="media-body">
                              <p class="text-muted mb-1 item-name">{{ product.item_name }}</p>
                              <h6>
                                <span class="badge badge-soft-light text-muted">ASIN:</span>
                                <span class="badge badge-soft-light text-black mx-1">{{ product.asin }}</span>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-card>
                </label>
              </b-col>
              <!-- end col -->
            </b-row>
            <!-- end row -->
            <div class="row">
              <div class="col-12">
                <div class="text-center my-3">
                  <infinite-loading @infinite="infiniteHandler" :identifier="infiniteId">
                    <div slot="spinner">{{ $t('pages.catalog.product_modal.loading') }}...</div>
                    <div slot="no-more">{{ $t('pages.catalog.product_modal.no_more') }}...</div>
                    <div slot="no-results">{{ $t('pages.catalog.product_modal.no_result') }}...</div>
                  </infinite-loading>
                </div>
              </div>
              <!-- end col-->
            </div>
          </simplebar>
          <!-- end row -->
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CatalogService from "../../../../Services/Api/CatalogService";
import InfiniteLoading from 'vue-infinite-loading';
import simplebar from "simplebar-vue";

export default {
  name: "CatalogProductsModal",
  components: {InfiniteLoading, simplebar},
  data() {
    return {
      catalog: [],
      selected: [],
      search: '',
      paginate: 50,
      page: 1,
      infiniteId: 0
    }
  },
  watch: {
    search() {
      this.catalog = []
      this.page = 1
      this.infiniteId += 1
    }
  },
  methods: {
    selectProduct(e, product) {
      if (e) {
        this.selected.push({
          id: product.id,
          asin: product.asin
        })
      } else {
        const selected = this.selected.findIndex(x => x.id === product.id && x.asin === product.asin)
        this.selected.splice(selected, 1)
      }
    },
    handleOk() {
      this.$emit('selected', this.selected)
    },
    close() {
      this.$emit('close')
      this.$bvModal.hide('catalog-product-modal')
    },
    handleHidden() {
      this.page = 1
      this.search = ''
      this.catalog = []
      this.selected = []
    },
    async infiniteHandler(state) {
      if (this.page > 1 && (this.catalog.length < this.paginate)) {
        state.complete()
        return
      }
      await CatalogService.modalAll({query: `paginate=${this.paginate}&page=${this.page}&filter=${this.search}`}).then((res) => {
        const data = res.data.data
        if (data.length > 0) {
          this.page += 1;
          this.catalog.push(...data);
          state.loaded();
        } else {
          state.complete();
        }
        res.data.data
      })
    }
  }
}
</script>

<style scoped>
.area {
  height: 300px !important;
  padding: 12px;
}
</style>